import React from 'react';
import { Button } from '@/components/ui/button';
import { Maximize, Minimize, Smartphone, Download } from 'lucide-react';
import { useFullscreen } from '@/hooks/useFullscreen';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { toast } from '@/hooks/use-toast';

export const FullscreenButton = () => {
  const { isFullscreen, requestFullscreen, exitFullscreen, isMobileDevice, isIOSDevice } = useFullscreen();
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt();

  console.log('🔍 [FULLSCREEN-BUTTON] Rendering:', {
    isMobileDevice,
    isIOSDevice,
    isInstallable,
    isInstalled,
    windowInnerHeight: window.innerHeight,
    windowInnerWidth: window.innerWidth
  });

  const handleFullscreenToggle = async () => {
    if (isFullscreen) {
      await exitFullscreen();
    } else {
      await requestFullscreen();
    }
  };

  const handleMobileAction = async () => {
    console.log('🔍 [FULLSCREEN-BUTTON] Mobile action triggered');
    
    if (isIOSDevice && !isInstalled) {
      toast({
        title: "Add to Home Screen",
        description: "For fullscreen: Tap Share button in Safari → Add to Home Screen",
        duration: 6000,
      });
      return;
    }
    
    if (!isInstalled && isInstallable) {
      const success = await promptInstall();
      if (success) {
        toast({
          title: "App Installing",
          description: "Install for better fullscreen experience",
        });
      }
      return;
    }
    
    // Fallback: attempt fullscreen or show immersive mode
    await requestFullscreen();
  };

  // Always show button on mobile - simplified logic
  if (isMobileDevice) {
    const getButtonContent = () => {
      if (isIOSDevice && !isInstalled) {
        return (
          <>
            <Download className="h-4 w-4 mr-1" />
            Add to Home
          </>
        );
      }
      if (!isInstalled && isInstallable) {
        return (
          <>
            <Download className="h-4 w-4 mr-1" />
            Install
          </>
        );
      }
      return (
        <>
          {isFullscreen ? <Minimize className="h-4 w-4 mr-1" /> : <Maximize className="h-4 w-4 mr-1" />}
          {isFullscreen ? 'Exit' : 'Fullscreen'}
        </>
      );
    };

    return (
      <Button
        variant="outline"
        size="sm"
        onClick={handleMobileAction}
        className="fixed top-4 right-4 z-50 bg-background/90 backdrop-blur-sm border-2 shadow-lg"
      >
        {getButtonContent()}
      </Button>
    );
  }

  // Desktop - simple fullscreen toggle
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleFullscreenToggle}
      className="fixed top-4 right-4 z-50 bg-background/80 backdrop-blur-sm"
    >
      {isFullscreen ? <Minimize className="h-4 w-4" /> : <Maximize className="h-4 w-4" />}
    </Button>
  );
};